<div id="dialog-toast-main-container" *ngIf="true" class="popup-main-toast-container" [ngClass]="toastClass ?  toastState + ' createUser-margin' : toastState">
    <div id="dialog-toast-content-container" class="popup-toast-content-container">
        <span id="dialog-toast-span">{{ toastMessage }}</span>
    </div>
    <div id="dialog-toast-image-container" class="popup-image-container">
        <img id="dialog-toast-img" [src]="getImageForToast()"  width="24" height="24" alt="toast"/>
    </div>
  </div>